<template>
  <Forms  ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
          >
         <!-- <div id="form-filter-folder">
              <div class="mt-2" v-for="t in dataFolders" :key="t.credenciadaId">
                  <FilterGroupPaste v-on:selectFilterParamWatch="selectFilterParam" v-on:filterById="filterById"  ref="pasteRef"  :accordion="'lista'" :id="t.credenciadaId" :title="t.credenciadaNome">
                    <div v-for="test in t.corretores" v-bind:key="test.contaId" v-on:click="GetAllCorretorsFilter(test.contaId, $event)" class="names-folder ml-4 mt-2">{{test.corretorNome}}</div>
                 </FilterGroupPaste>
              </div>
          </div> -->
              <div id="form-search">
              <div class="margem">
                <label class="labelseach">Imobiliária</label>
                    <autocomplete-z ref="ImobliariaTypeahead"
                          placeholder="Digite uma imobiliária"
                          iconClass="fas fa-sign"
                          :serializer="(Imobiliaria) => Imobiliaria.nome"
                          :debounceLength="3"
                          :formField="SearchItems.imobiliariaObj"
                          v-on:search="onSearchImobliaria"
                          v-on:changeCode="onSearchImobliaria"
                          :ShowCode="false"
                           />
              </div>
              <div class="margem">
                <label class="labelseach">Corretor</label>
                <autocomplete-z ref="ClienteTypeahead"
                            placeholder="Digite um corretor"
                            iconClass="fas fa-user"
                            :serializer="(corretor) => corretor.nome"
                            :debounceLength="2"
                            :formField="SearchItems.corretor"
                            v-on:search="onSearchUsuario"
                            v-on:changeCode="onSearchUsuario"
                            :ShowCode="false"
                            />
              </div>
            </div>
    </Forms>

</template>

<script>
import FilterFolder from './filterfolder'
export default FilterFolder
</script>

<style scoped>
.margem{
  margin-bottom: 0.5rem;
}
.names-folder{
  font-size: 15px;
  width: 90%;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;

}
.names-folder-active{
  font-size: 15px;
  width: 90%;
  color: #008148;
  background-color: #E9ECEF;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;
}
.labelseach{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
.labelseach-ate {
    margin-top: 10px;
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
.names-folder{
  font-size: 15px;
  width: 90%;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;

}
.names-folder-active{
  font-size: 15px;
  width: 90%;
  color: #008148;
  background-color: #E9ECEF;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;
}
#form-filter-folder{
  height: 60vh;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/filterfolder/filterfolder.vue